/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import BreastImaging from "../../../../assets/final-images/servicepage/womens-page/patient_big.jpg";
import { Link } from "react-router-dom";
import { useLenis } from "../../../SmoothScroll";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import mammography from "../../../../assets/final-images/servicepage/womens-page/Artboard 1.jpg";
import BreastMRI from "../../../../assets/final-images/servicepage/womens-page/Artboard 2.jpg";
import BrestUltrasound from "../../../../assets/final-images/servicepage/womens-page/Artboard 3.jpg";
import shapeImage from "../../../../assets/final-images/shapes/9-01.png";
import shape from "../../../../assets/final-images/shapes/16-01.png";
import Faqs from "../../../Faqs";
import { Helmet } from "react-helmet-async";
export default function WomensImaging() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  const faqs = [
    {
      question: "Does Citrus Diagnostic Center offer mammography screening?",
      answer:
        "Yes. Citrus Diagnostic Center offers mammography for both screening and diagnostic purposes at our Crystal River, FL facility. Screening mammography is recommended annually for average-risk women beginning at age 40 by the American Cancer Society. Diagnostic mammography is ordered when there is a specific concern - such as a palpable lump, nipple discharge, or abnormal screening result - and involves more targeted imaging with immediate radiologist review.",
    },
    {
      question:
        "What is the difference between screening and diagnostic mammography?",
      answer:
        "Screening mammography is a routine exam performed on women with no breast symptoms or known abnormalities, using standard views of each breast. Diagnostic mammography is ordered when there is a specific clinical concern and involves additional customized views, magnification images, or ultrasound correlation interpreted by the radiologist before you leave. Diagnostic mammograms typically take longer than screening exams. Your physician's order will specify which type is required.",
    },
    {
      question:
        "How should I prepare for a mammogram at Citrus Diagnostic Center?",
      answer:
        "On the day of your mammogram, avoid applying deodorant, antiperspirant, powder, lotion, or perfume under your arms or on your breasts, as these can appear as artifacts on the images. Wear a two-piece outfit so you only need to undress from the waist up. Bring prior mammogram images or records if they were performed elsewhere so our radiologist can make comparisons. Schedule your mammogram when your breasts are least tender - typically the week after your menstrual period.",
    },
    {
      question: "Is mammography covered by insurance and Medicare?",
      answer:
        "Yes. Screening mammography is covered at no cost to the patient by most commercial insurance plans under the Affordable Care Act's preventive services mandate for women aged 40 and older. Medicare Part B covers one screening mammogram per year for women over 40, also with no cost-sharing. Diagnostic mammography is covered under standard medical benefits, subject to deductible and copay. Our billing team can verify your coverage when you call to schedule.",
    },
    {
      question: "What is breast density and why does it matter?",
      answer:
        "Breast density refers to the relative amount of fibroglandular tissue compared to fatty tissue in the breast, as seen on mammography. Dense breasts are common - affecting approximately 40% of women - and are significant for two reasons: dense tissue can partially obscure small tumors on mammography (reducing sensitivity), and dense breast tissue is itself an independent risk factor for breast cancer. Florida law requires that patients be notified if their mammogram shows dense breast tissue, and supplemental screening with breast ultrasound or MRI may be recommended for high-risk patients.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>Women’s Imaging Center | Citrus Diagnostic Center Florida</title>
        <meta
          name="description"
          content="What does women’s imaging include? Breast imaging, mammography, and ultrasound focused on early detection, personalized screening, and clear evaluation.
"
        />
        <meta
          name="keywords"
          content="women's imaging center
women's radiology center
women's center for radiology
women's breast imaging
breast imaging
breast ultrasound
mammography screening
prenatal imaging
breast imaging center


"
        />
      </Helmet>
      <div className=" font-robout">
        <div className="flex flex-col justify-center items-center px-5 xl:px-0 xl:pb-24 xl:pt-36 text-center">
          <h1
            data-aos="fade-right"
            className="font-heading lg:text-[72px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal  capitalize"
          >
            Women’s Imaging at Citrus Diagnostic Center
          </h1>
          <p
            data-aos="fade-right"
            data-aos-delay="100"
            className=" text-[#cccccc] font-normal "
          >
            Focused on early detection. Designed around you.
          </p>
        </div>
      </div>
      <div className="relative 3xl:py-28 ">
        <img
          src={shapeImage}
          alt="Citrus Diagnostic Center"
          className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-35
      
    "
        />
        <div className="md:max-w-[90%] w-11/12 mx-auto xl:bg-[#0f0f0f] rounded-xl py-16">
          <div
            className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10  backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl w-full xl:w-[90%] mx-auto px-5   py-8 xl:p-16
      shadow-lg"
          >
            <div className="">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                  A Comprehensive Approach to Breast Care
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Women’s imaging is not one-size-fits-all.
                </p>
              </div>
              <p className="pb-2">
                At Citrus Diagnostic Center, we provide{" "}
                <span className="font-extrabold">
                  comprehensive breast imaging
                </span>{" "}
                that integrates:
              </p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Risk assessment</span>
                </li>
                <li className="flex items-start gap-2">
                  <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Advanced screening</span>
                </li>
                <li className="flex items-start gap-2">
                  <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Diagnostic problem-solving</span>
                </li>
                <li className="flex items-start gap-2">
                  <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>High-level MRI evaluation</span>
                </li>
              </ul>
              <p className="py-2">
                All imaging is{" "}
                <span className="font-extrabold">
                  radiologist-led, evidence-based
                </span>
                , and designed around the individual patient.
              </p>
            </div>
            <div>
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                  Breast Cancer Risk Assessment
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Imaging guided by personalized risk.
                </p>
              </div>
              <p className="pb-2">
                Understanding breast cancer risk is a critical first step in
                choosing the right imaging strategy.
              </p>
              <p className="pb-2">
                We utilize validated risk assessment tools, including the{" "}
                <span className="font-extrabold whitespace-nowrap">
                  Tyrer–Cuzick (IBIS) model
                </span>
                , to help:
              </p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-1">
                  <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Estimate lifetime breast cancer risk</span>
                </li>

                <li className="flex items-start gap-1">
                  <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>
                    Identify patients who may benefit from enhanced screening
                  </span>
                </li>

                <li className="flex items-start gap-1">
                  <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Support risk-based imaging recommendations</span>
                </li>
              </ul>
              <p className="py-2">
                Risk assessment allows imaging to be{" "}
                <span className="font-extrabold">personalized</span>, not
                generic.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
      >
        <div className="md:max-w-[90%] w-11/12 mx-auto">
          <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 lg:pt-16 pb-10 pt-10">
            <div className="flex justify-normal items-center bg-[#0f0f0f] py-4 rounded-xl order-2 xl:order-1">
              <img src={mammography} alt="3d mammography" />
            </div>
            <div className="flex flex-col justify-center order-1 xl:order-2">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                  3D Mammography (Tomosynthesis)
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Clearer images. Greater confidence.
                </p>
              </div>
              <p className="pb-2">
                3D mammography improves visualization by creating layered images
                of the breast.
              </p>
              <p className="pb-2">Benefits include:</p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Improved cancer detection</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Reduced false positives</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Better evaluation of dense breast tissue</span>
                </li>
              </ul>
              <p className="py-2">
                All exams are interpreted by{" "}
                <span className="font-extrabold">
                  board-certified radiologists
                </span>
                , with AI-assisted tools supporting consistency and detection.
              </p>
            </div>
          </div>

          <div className="bg-[#0f0f0f] rounded-xl p-5 xl:p-20 ">
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10  ">
              <div>
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    Breast MRI
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    The most sensitive breast imaging modality.
                  </p>
                </div>
                <p className=" pb-2">Breast MRI is a powerful tool used in:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>High-risk screening</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Further evaluation of abnormal findings</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>
                      Extent-of-disease assessment after cancer diagnosis
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>
                      Problem-solving when conventional imaging is inconclusive
                    </span>
                  </li>
                </ul>
                <p className="pt-5 pb-2 text-[#cccccc] font-normal">
                  Why Breast MRI Matters:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-1">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Superior sensitivity for cancer detection</span>
                  </li>

                  <li className="flex items-start gap-1">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Excellent evaluation of dense breast tissue</span>
                  </li>

                  <li className="flex items-start gap-1">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>No ionizing radiation</span>
                  </li>
                </ul>
                <p className="pt-5 pb-2 text-[#cccccc] font-normal">
                  At Citrus Diagnostic Center:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>
                      Breast MRI protocols are{" "}
                      <span className="font-extrabold">
                        radiologist-designed
                      </span>
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>
                      Studies are interpreted in full clinical context
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>
                      Imaging is integrated with mammography, ultrasound, and
                      risk assessment
                    </span>
                  </li>
                </ul>
                <p className="py-2">
                  This allows for{" "}
                  <span className="font-extrabold">
                    coordinated, comprehensive breast care
                  </span>
                  .
                </p>
              </div>
              <div className="flex justify-normal items-center bg-[#0f0f0f] py-4 ">
                <img
                  src={BreastMRI}
                  alt="Breast MRI"
                  className="bg-[#000] p-10 rounded-xl"
                />
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 xl:mt-24 ">
              <div className="flex justify-normal items-center order-2 xl:order-1">
                <img
                  src={BrestUltrasound}
                  alt="Breast Ultrasound"
                  className="bg-[#000] p-10 rounded-xl"
                />
              </div>
              <div className="order-1 xl:order-2">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    Breast Ultrasound
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    Targeted imaging when additional detail is needed.
                  </p>
                </div>
                <p className="pb-2">Breast ultrasound is commonly used to:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Evaluate palpable findings</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Further assess mammographic abnormalities</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Complement screening in dense breast tissue</span>
                  </li>
                </ul>
                <p className="py-2">It is:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-1">
                    <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Radiation-free</span>
                  </li>

                  <li className="flex items-start gap-1">
                    <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Real-time</span>
                  </li>

                  <li className="flex items-start gap-1">
                    <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Comfortable and non-invasive</span>
                  </li>
                </ul>
                <p className="py-2">
                  Ultrasound is used thoughtfully-as part of a complete imaging
                  strategy.
                </p>
              </div>
            </div>
          </div>
          <div className=" lg:py-20 py-10">
            <img
              src={BreastImaging}
              alt="women's imaging center"
              className="w-full h-auto object-cover rounded-xl"
            />
          </div>
        </div>
      </div>
      <div className=" md:max-w-[90%] w-11/12 mx-auto py-20">
        <div
          className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 md:py-16 py-10 px-5 xl:px-10 rounded-xl "
          style={{
            background:
              "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
          }}
        >
          <div className=" 2xl:px-12 xl:px-8 xl:py-10 flex justify-center items-start flex-col">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                Diagnostic & Follow-Up Imaging
              </h2>
              <p className=" text-[#cccccc] font-normal">
                Clarity when questions arise.
              </p>
            </div>
            <p className="pb-2">
              When screening identifies an area of concern, diagnostic imaging
              may include:
            </p>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Targeted mammographic views</span>
              </li>
              <li className="flex items-start gap-2">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Focused ultrasound</span>
              </li>
              <li className="flex items-start gap-2">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Breast MRI when appropriate</span>
              </li>
            </ul>
            <p className="py-2">Our team prioritizes:</p>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Clear communication</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Timely scheduling</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Compassionate support throughout the process</span>
              </li>
            </ul>
          </div>
          <div className="2xl:px-12 xl:px-8 xl:py-10">
            <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  pb-8">
              Designed for Comfort, Safety, and Access
            </h2>
            <p className="pb-2">
              Women’s imaging at Citrus Diagnostic Center prioritizes both
              diagnostic quality and patient experience.
            </p>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-1">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>
                  Enhanced comfort features to reduce compression discomfort
                </span>
              </li>

              <li className="flex items-start gap-1">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Dose-conscious 3D mammography technology</span>
              </li>

              <li className="flex items-start gap-1">
                <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>
                  Secure digital delivery of mammography results and patient
                  letters through our patient portal
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="relative">
        {/* 🔥 Background Shape */}
        <img
          src={shape}
          alt="
women's radiology center

"
          className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-35
    "
        />
        <div className="md:max-w-[90%] w-11/12 mx-auto">
          <div
            className="grid lg:grid-cols-2 lg:gap-20 gap-10 py-16 md:px-10 px-4 backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl
      shadow-lg  xl:p-16"
          >
            <div className="">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                  For Referring Providers
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Risk-based imaging you can trust.
                </p>
              </div>
              <p className="pb-2">
                Women’s imaging at Citrus Diagnostic Center offers:
              </p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Risk assessment–informed screening strategies</span>
                </li>

                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>
                    Breast MRI for high-risk and diagnostic indications
                  </span>
                </li>

                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>AI-supported mammography</span>
                </li>

                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Clear, actionable reports</span>
                </li>

                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Direct radiologist collaboration</span>
                </li>
              </ul>
              <p className="py-2">
                We support primary care providers, gynecologists, and
                specialists with{" "}
                <span className="font-extrabold">
                  imaging aligned to clinical risk and evidence-based
                  guidelines.
                </span>
              </p>
            </div>
            <div className="">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                  For Patients
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Knowledge empowers confidence.
                </p>
              </div>
              <p className="pb-2">We believe women deserve:</p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Clear information about their risk</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Imaging tailored to their needs</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>A choice in where imaging is performed</span>
                </li>
              </ul>
              <p className="py-2">
                Our team is here to guide you-every step of the way.
              </p>
            </div>
          </div>
          <div
            className=" md:px-10 px-4 backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl
      shadow-lg   py-8 xl:p-16 mt-10"
          >
            <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  pb-8">
              Why Choose Citrus Diagnostic Center for Women’s Imaging
            </h2>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Radiologist owned and operated</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>3D mammography with AI support</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span className="font-extrabold">
                  Breast MRI for comprehensive evaluation
                </span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span className="font-extrabold">
                  Risk-based screening using Tyrer–Cuzick assessment
                </span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Compassionate, patient-centered care</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                <span>Trusted community provider for over 30 years</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="lg:w-[80%] w-[90%] mx-auto py-8 ">
        <Faqs faqs={faqs} />
      </div>
      <div className="md:max-w-[90%] w-11/12 mx-auto mb-10">
        <div className="flex justify-center items-center pt-14">
          <div
            style={{
              background: `
                      linear-gradient(90deg,
                    #3d0e26 0%,
                    #5a1f33 1%,
                    #8b5e3c 40%,
                    #8b5e3c 70%,
                    #5a1f33 95%,
                    #330a16 100%
                  )
                    `,
            }}
            className="flex justify-center items-center flex-col py-8 px-6 xl:px-8 rounded-xl xl:w-[668px] "
          >
            <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
              Schedule with Confidence
            </h2>
            <p className=" pt-5  text-center">
              Comprehensive women’s imaging-guided by expertise,
              personalization, and care.
            </p>
            <div className="pt-10 pb-2">
              <Link
                data-aos="fade-up"
                to="/contact-us"
                aria-label="Schedule Now"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Schedule Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
